import axios, { AxiosResponse } from 'axios';

export const baseUrl = `${
  import.meta.env?.VITE_APP_BACKEND || 'http://localhost:3010'
}`;
const axiosParams = {
  baseURL: baseUrl,
};

export const axiosInstance = axios.create(axiosParams);

export const responseBody = (response: AxiosResponse) => response.data;

export const getEndpoint: (query: string) => string = (query) => {
  return `${baseUrl}/${query}`;
};
